import { routerNavigatedAction } from '@ngrx/router-store';
import { on } from "@ngrx/store";

import { dayjs } from '../../../core/dayjs/dayjs';
import { LoadingState } from '../../../utilities/state.util';


import { DiscardOpportunityDialogActions } from "../../job-create/discard-job-component/discard-job.actions";
import { JobCreateCustomerActions } from "../../job-create/job-create-customer/job-create-customer.actions";

import { JobFormActionButtonActions } from "../../job-create/job-form-action-button/job-form-action-button.actions";
import { JobToolActions } from "../../job-tool.actions";

import { OverviewTimelineActions } from "./overview-timeline.actions";
import { OverviewTimelineState, overviewTimelineInitialState } from "./overview-timeline.state";

export const overviewTimelineReducers = [
  on(
    OverviewTimelineActions.fetchViewDatesStarted,
    (state: OverviewTimelineState): OverviewTimelineState => ({
      ...state,
      viewDatesLoading: LoadingState.LOADING,
    }),
  ),
  on(
    JobToolActions.jobLoaded,
    JobToolActions.jobDataReset,
    JobCreateCustomerActions.updateCustomerDataSuccess,
    JobFormActionButtonActions.updateJobSuccess,
    (state: OverviewTimelineState, action): OverviewTimelineState => {

      const job = 'updatedJob' in action ? action.updatedJob : action.job;

      if (!job.timeline) {
        return {
          ...state,
          timeline: [],
        }
      };

      const timeline: string[] = [];

      const timelineStartDayjs = dayjs(job.timeline, 'YYYY-MM-DD');

      timeline.push(timelineStartDayjs.format('YYYY-MM-DD'));

      if (job.timelineDays) {
        const timelineEndDayjs = timelineStartDayjs.add(job.timelineDays, 'days');
        timeline.push(timelineEndDayjs.format('YYYY-MM-DD'));
      }

      return {
        ...state,
        timeline,
      }
    }
  ),
  on(
    OverviewTimelineActions.timelineDatesSelected,
    (state: OverviewTimelineState, { timeline }): OverviewTimelineState => {

      if (timeline.length > 1) {

        const startStr = timeline[0];
        const endStr = timeline[1];

        const start = dayjs(startStr);
        const end = dayjs(endStr);
        const days = end.diff(start, 'days');

        // Requirement: [6419] - Allow to select time range up to 90 days
        if (days > 90) {
          timeline = [ endStr ];
        }
      }

      return {
        ...state,
        timeline,
      }
    }
  ),
  on(OverviewTimelineActions.openActionsMenuButtonClicked, (state: OverviewTimelineState, { eventId }): OverviewTimelineState => {
    return {
      ...state,
      timelineActionsEventId: eventId,
    }
  }),
  on(OverviewTimelineActions.fetchViewDatesSuccess, (state: OverviewTimelineState, { viewDates }): OverviewTimelineState => {
    const newEntries: Record<string, typeof viewDates[number]> = {};
    for (const vd of viewDates) {
      if (vd) {
        newEntries[vd.date] = vd;
      }
    }
    return {
      ...state,
      viewDatesMap: { ...state.viewDatesMap, ...newEntries },
      viewDatesLoading: LoadingState.LOADED,
    }
  }),
  on(OverviewTimelineActions.fetchViewDatesError, (state: OverviewTimelineState): OverviewTimelineState => {
    return {
      ...state,
      viewDatesLoading: LoadingState.LOADED,
    }
  }),
  on(DiscardOpportunityDialogActions.discardUnsavedChangesButtonClicked, (): OverviewTimelineState => overviewTimelineInitialState),
  on(routerNavigatedAction, (state: OverviewTimelineState, { payload: { event: { urlAfterRedirects } } }): OverviewTimelineState => {
    if (
      urlAfterRedirects.startsWith('/jobs/new') ||
      /^\/jobs\/[^/]+$/.test(urlAfterRedirects)
    ) {
      return overviewTimelineInitialState;
    }
    return state;
  }),
];
